export default function usePrices() {
  const convertBRLPriceInNumber = (brlPrice) => {
    if (typeof brlPrice !== 'string') return brlPrice;

    const [, monetaryValue] = brlPrice.split('R$');
    if (!monetaryValue) {
      throw new Error('Your string must contain R$');
    }

    const price = monetaryValue.trim().replace(',', '.');
    return parseFloat(price);
  };

  const convertNumberInBRLPrice = (number, shouldParse = false) => {
    if (typeof number !== 'number' && typeof number !== 'string') return number;

    let value = number;
    if (typeof number === 'string') {
      value = parseFloat(number);
    }

    if (shouldParse) {
      value /= 100;
    }

    const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    return formatter.format(value);
  };

  const formatPercentage = (value) => {
    const num = Number(value);
    if (isNaN(num) || num === 0) return '-';

    return `${num.toFixed(2).replace('.', ',')}%`;
  };

  return { convertBRLPriceInNumber, convertNumberInBRLPrice, formatPercentage };
}
